module.exports = __webpack_public_path__ + "img/1.10751b93.png";